import request from '@/utils/request'
// 获取产品
export function getProduct (data) {
  return request({
    url: '/ProductApi/Index',
    method: 'post',
    data
  })
}
// 产品信息详情
export function getProductShow (data) {
  return request({
    url: '/ProductApi/Show',
    method: 'post',
    data
  })
}
// 全部产品信息下载
export function getProductDown (data) {
  return request({
    url: '/ProductApi/ProductDownIndex',
    method: 'post',
    data
  })
}
// 产品下载详情
export function getProductShowDown (data) {
  return request({
    url: '/ProductApi/ProductDownShow',
    method: 'post',
    data
  })
}
